// extracted by mini-css-extract-plugin
export default {"mCard":"QB-z","image":"RB-z","imageNoBackground":"SB-z","imageHasCategory":"TB-z","fullWidth":"UB-z"};